"use client";
import Link from "next/link";

interface ProfileUpsellCardProps {
    text: string;
    href: string;
    status: "View" | "Buy";
    onClick: () => void;
}

export const ProfileUpsellCard = ({ href, status, text, onClick }: ProfileUpsellCardProps) => {
    return (
        <Link
            className="p-4 flex justify-between gap-2 border-2 border-white-600 bg-white-900 rounded-2xl hover:bg-white-800"
            href={href}
            target={status === "View" ? "_blank" : "_self"}
            onClick={onClick}
        >
            <p className="text-black">{text}</p>
            <p className="text-blue-600">{status}</p>
        </Link>
    );
};
